import { useCallback } from 'react';

import { type User, type Workspace } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type CreatedWorkspaceLocation } from './useTrackCreatedWorkspace.meta';

export { CREATED_WORKSPACE_LOCATIONS, type CreatedWorkspaceLocation } from './useTrackCreatedWorkspace.meta';

export type CreatedWorkspace = Pick<Workspace, 'id' | 'name'> & {
  location: CreatedWorkspaceLocation;
  creatorId: User['id'];
};

export const useTrackCreatedWorkspace = () => {
  const { track, setGlobalEventProps } = useAnalyticsUtilities();

  const trackCreatedWorkspace = useCallback(
    (params: CreatedWorkspace) => {
      setGlobalEventProps({ workspaceId: params.id, workspaceName: params.name });
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [setGlobalEventProps, track],
  );

  return { trackCreatedWorkspace };
};
